// extracted by mini-css-extract-plugin
export default {"main":"ResetPasswordModal_main__L+KvE","container":"ResetPasswordModal_container__zvEVZ","form":"ResetPasswordModal_form__Ixcal"};